import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { BlueprintRole } from '@mn/shared';
import { useRoleContext } from '../lib/role-context';

/**
 * Route guard that gates children on the active (preview) Blueprint role.
 * Blueprint admins are always allowed. Mirrors the visibility encoded in
 * nav-config.ts so directly navigating to a hidden route shows a permission
 * message instead of management content. The API enforces the real boundary.
 */
export function RequireRole({
  roles,
  children,
}: {
  roles: BlueprintRole[];
  children: ReactNode;
}) {
  const { t } = useTranslation('common');
  const { activeRole } = useRoleContext();

  const allowed = activeRole === 'BLUEPRINT_ADMIN' || roles.includes(activeRole);

  if (!allowed) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">{t('noPermission')}</p>
      </div>
    );
  }

  return <>{children}</>;
}
